<template>
    <div v-if="account && account.status.color"
         :id="rowId"
         class="account-row"
         :class="{ 'is-active': isHovering }"
         v-on:mouseover="changeActiveHoverIn"
         v-on:mouseleave="changeActiveHover">
        <ul :style="'border-left-color: ' + account.status.color">
            <li class="account-row-favorite">
                <favorite model="accounts" :model-id="account.id" :favorite="account.favorite" v-on:change="getAccounts" />
            </li>
            <li class="account-row-status">
                <b-dropdown v-if="userCanUpdateStatus">
                    <span class="tag" slot="trigger"
                          v-on:click="isHovering = true"
                          :class="fontColor(account.status.color.toString())"
                          :style="'background-color: ' + account.status.color">
                        {{ account.status.name }}
                    </span>

                    <b-dropdown-item
                            v-on:mouseover="changeActiveHoverIn"
                            v-for="status in account.statuses" :key="status.id"
                            :class="{ 'is-selected': status.name === account.status }"
                            @click="changeStatus(account, status)">
                        {{ status.name }}
                    </b-dropdown-item>
                </b-dropdown>
                <template v-else>
                    <b-tag :class="[fontColor(account.status.color.toString()), 'is-fake']"
                          :style="'background-color: ' + account.status.color">
                        {{ account.status.name }}
                    </b-tag>
                </template>
            </li>
            <li class="account-row-name">
                <router-link
                        :to="{path: `accounts/${account.id}`}"
                        title="View Account">
                    {{ account.name.value }}
                </router-link>
            </li>
            <li class="account-row-account">
                {{ account.account_number }}
            </li>
            <li class="account-row-data">
                <div class="account-row-data-info">
                    <b-tooltip label="Account Properties">
                        <b-icon icon="map-pin" />
                    </b-tooltip>
                    <span class="info-label">{{ account.properties | numberFormat }}</span>
                </div>
                <div class="account-row-data-info">
                    <b-tooltip label="Account Files">
                        <b-icon icon="folder-open" />
                    </b-tooltip>
                    <span class="info-label">{{ account.files.total | numberFormat }}</span>
                </div>
                <div class="account-row-data-info" v-if="account.type === 'standard'">
                    <b-tooltip label="Account Users">
                        <b-icon icon="users" />
                    </b-tooltip>
                    <span class="info-label">{{ account.users | numberFormat }}</span>
                </div>
            </li>
            <li class="account-row-buttons has-text-right">
                <router-link :to="{path: `/quickview/accounts/${account.id}`}">
                   Quick View
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import fontColor from '@/functions/fontColor'
import { ACCOUNT_STATUS_SET } from '@/store/actions/accounts'
import Favorite from '@/components/Elements/Favorite'

export default {
  name: 'AccountRow',
  props: {
    account: {
      type: Object
    },
    infoCols: {
      default: 'is-three-fifths',
      type: String
    }
  },
  components: {
    Favorite
  },
  data () {
    return {
      isHovering: false
    }
  },
  computed: {
    ...mapGetters({
      userCan: 'userCan'
    }),
    userCanUpdateStatus: function () {
      if (!this.userCan('update_account_status', 'accounts')) return false
      if (this.account.type === 'standard' || this.userCan('manage_simple_accounts', 'accounts')) return true

      return false
    },
    rowId: function () {
      if (!this.account) return ''
      return 'account-row-' + this.account.id
    }
  },
  methods: {
    fontColor: fontColor,
    handleError (err) {
      if (err.hasOwnProperty('response')) {
        if (err.response.data.response === 'error') {
          this.$awn.warning(err.response.data.message)
        }
      } else {
        this.$awn.alert(err.toString())
      }
    },
    changeStatus: function (account, status) {
      this.$set(account, 'status', status)

      const accountId = account.id
      const statusId = status.id

      this.$store.dispatch(ACCOUNT_STATUS_SET, { accountId, statusId }).then(response => {
        this.$awn.success(response.message)
      }).catch(err => {
        this.handleError(err)
      })
    },
    changeActiveHover: function () {
      let thisRow = document.getElementById(this.rowId)
      let dropdownOpen = thisRow.querySelector('.dropdown.is-active')
      if (dropdownOpen) {
        this.isHovering = true
      } else {
        setTimeout(() => {
          this.isHovering = false
        }, 401)
      }
    },
    changeActiveHoverIn: function () {
      let dropdownOpen = document.querySelectorAll('.dropdown.is-active').length
      if (dropdownOpen) {
        this.isHovering = true
      } else {
        setTimeout(() => {
          this.isHovering = false
        }, 401)
      }
    },
    getAccounts: function () {
      this.$store.dispatch('accounts/getRecentlyActiveAccounts')
      this.$store.dispatch('accounts/getFavoriteAccounts')
    }
  },
  created () {
    //
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Account/Dashboard/AccountRow.vue